import books from "../assets/images/books.svg";
import briefcase from "../assets/images/briefcase.svg";
import dashboard from "../assets/images/dashboard.svg";
import robot from "../assets/images/agentLite.svg";
import users from "../assets/images/users.svg";
import notificationConfiguration from "../assets/images/notificationConfiguration.svg";
import auditLogs from "../assets/images/check.svg";

const sidebarItems = [
  {
    label: "Dashboard",
    value: "dashboard",
    route: "dashboard",
    image: dashboard,
    alt: "Dashboard",
    width: "20px",
    // users: ["super_admin", "agent_admin", "organization_admin"],
    users: ["super_admin"],
  },
  {
    label: "Agent Screen",
    value: "botScreen",
    route: "botscreen",
    image: robot,
    alt: "Agent Screen",
    width: "20px",
    users: ["agent_admin"],
  },
  {
    label: "Organization",
    value: "organization",
    route: "organisation",
    image: briefcase,
    alt: "Organization",
    width: "20px",
    users: ["super_admin", "organization_admin"],
  },
  {
    label: "User Management",
    value: "users",
    route: "users",
    image: users,
    alt: "Users",
    width: "20px",
    users: ["super_admin", "organization_admin"],
  },
  {
    label: "Task Library",
    value: "task_library",
    route: "task_library",
    image: books,
    alt: "Task Library",
    width: "20px",
    users: ["organization_admin", "agent_admin"],
  },
  {
    label: "Notification Configuration",
    value: "notification_configuration",
    route: "notification_configuration",
    image: notificationConfiguration,
    alt: "Notification Configuration",
    width: "25px",
    users: ["organization_admin"],
  },
  // {
  //   label: "Agent Lite",
  //   value: "agentLite",
  //   route: "aiAgents",
  //   image: robot,
  //   alt: "Agent Lite",
  //   width: "25px",
  //   users: ["organization_admin", "agent_admin"],
  // },
  {
    label: "Audit Logs",
    value: "audit_logs",
    route: "audit_logs",
    image: auditLogs,
    alt: "Audit Logs",
    width: "20px",
    users: ["super_admin"],
  },
];

export default sidebarItems;
